import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import AdminUserForm from '../AdminUserForm';

import { closeAdminUserModal } from '../../../actions/siteadmin/modalActions';
import messages from '../../../locale/messages';

import s from './AdminUserModal.css';

class AdminUserModal extends Component {
  static defaultProps = {
    adminUserModalType: 'add'
  };
  constructor(props) {
    super(props);
  }
  render() {
    const { closeAdminUserModal, adminUserModal, adminUserModalType, roles, paginationData, currentPage } = this.props;
    return (
      <Modal show={adminUserModal} onHide={closeAdminUserModal} dialogClassName='commonModalContainer'>
        <Modal.Header closeButton className='commonModalHeader'>
          <Modal.Title>
            <div className='commonModalTitle'>
              <FormattedMessage {...messages[adminUserModalType == 'add' ? 'addAdminUserLabel' : 'editAdminUserLabel']} />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='commonModalBody'>
          <AdminUserForm roles={roles} paginationData={paginationData} currentPage={currentPage} />
        </Modal.Body>
      </Modal>
    )
  }
}
const mapState = (state) => ({
  adminUserModal: state?.adminModalStatus?.adminUserModal,
  adminUserModalType: state?.adminModalStatus?.adminUserModalType
});
const mapDispatch = {
  closeAdminUserModal
};
export default withStyles(s)(connect(mapState, mapDispatch)(AdminUserModal));
